import {  useRef, useState, useEffect} from "react";
import {
  FormControl,
  FormHelperText,
  FormControlLabel,
  RadioGroup,
  Radio,
  Checkbox,
  FormGroup,
  MenuItem,
  LinearProgress,
  IconButton,
  Tooltip,
  Typography
} from "@mui/material";
import FormField from "../../styled/FormField";
import SelectField from "../../styled/SelectField";
import FormLabel from "../../styled/FormLabel";
import IosSwitch from "../../styled/Switch";
import DatePickerField from "../../common/DatePicker";
import _ from "lodash";
import {
  DeleteIconButton,
  DownIcon,
  EyeIconButton,
} from "../../../../assets/common-svg/CommonSvg";
import { UpperIcon } from "../../../assets/CommonSvg";
import FilePreviewModal from "../FilePreview";
import CustomDateRangePicker from "../../../../components/custom-date-picker/CustomDateRangePicker";
import DownloadFiles from '../DownloadFiles/index.js'

const FormikControl = ({
  label = "",
  type = "text",
  name,
  acceptFormat,
  downloadFile,
  inputClassName,
  removeFile,
  onChange,
  onBlurHandle= () => {},
  formik,
  required = false,
  multiple = false,
  placeholder = "",
  options = [],
  rows = 4,
  format = "DD/MM/YYYY",
  fullWidth = true,
  variant = "standard",
  min = 0,
  max,
  row,
  className = "",
  disabled = false,
  extraNote='',
  boundary=false,
  showMonthYearPicker=false,
  ...props
}) => {
  const renderField = () => {
    const [open, setOpen] = useState(false);
    const _dynmicFormik = (action) => {
      return _.get(formik[action], name, "");
    };
    const error = _dynmicFormik("touched") && Boolean(_dynmicFormik("errors"));
    const helperText = _dynmicFormik("touched") && _dynmicFormik("errors");
    switch (type) {
      case "text":
      case "email":
      case "number":
      case "time":
      case "password":
        return (
          <><FormField
            className={`${inputClassName} ${props?.extraContent ? '_border_right_none':''}`}
            autoComplete="off"
            type={type}
            name={name}
            value={_dynmicFormik("values")}
            placeholder={placeholder}
            // onChange={formik.handleChange}
            onWheel={(e) => { if (type === "number") { e.target.blur() } }}
            onChange={(e) => {
            if (onChange) {
              onChange(e);
              return;
            }
            const { value } = e.target;

           // Allow empty value to support clearing input
           if (value === "") {
             formik.handleChange(e);
             return;
           }
           

          if (props?.isTempratureField) {
            const num = Number(value);
            if (isNaN(num) || num < min || num > max) {
              return; // Prevent change if outside range
            }
          }
        
          // For valid inputs or non-temperature fields
          formik.handleChange(e);
        }}
            onBlur={(e) => {
              if (e.target.value == "" && type == "number") {
                formik.setFieldValue(name, "");
              }
              formik.handleBlur(e);
              if(onBlurHandle)
                onBlurHandle(e)
            }}
            error={Boolean(error)}
            helperText={helperText}
            disabled={disabled}
            InputProps={{
               ...(props?.extraContent && {
            endAdornment: (
              <span className="whitespace-nowrap text-gray-500 pr-1 text-[0.7rem] font-medium">
                {props?.extraContent}
              </span>
            )
           }),
             ...(type === "number" && {
          inputProps: {
            min,
            max,
            step: props?.notDecimal ? 1 : "any",
            inputMode: props?.notDecimal ? "numeric" : "decimal",
          },
                onKeyDown: (e) => {
                  if (e.key === " ") {
                    e.preventDefault();
                  }
                  if (type === "number") {
                    if ((props?.notDecimal && ["e", "E", ".", "+", "-", " "].includes(e.key)) || (props?.isTempratureField && ["e", "E", "+"].includes(e.key)) || (["e", "E", "-", "+"].includes(e.key))) {
                      e.preventDefault();
                    }
                  }
                },
              }),
              ...props.InputProps,
            }}
          />
          {extraNote ?
             <Typography
      variant="body2"
      color="#FB9D2C"
      className="absolute -bottom-4 left-0 text-xs"
    >
      {extraNote}
    </Typography>:''}
          </>
        );
      case "textarea":
        return (
           <FormField
            name={name}
            multiline
            rows={rows}
            value={formik?.values?.[name] ?? ""}
            placeholder={placeholder}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={Boolean(error)}
            helperText={helperText}
            disabled={disabled}
            sx={props.sx}
            className={props.className}
            InputProps={{
              ...props.InputProps,
            }}
          />
        );
      case "select":
        return (
          <>
            <SelectField
            open={open}
            onOpen={() => setOpen(true)}
            onClose={() => setOpen(false)}
            IconComponent={open ? UpperIcon : disabled ? "" : DownIcon}
            name={name}
            className={inputClassName}
            label={"dddd"}
            multiple={multiple}
            value={_dynmicFormik("values")}
            onChange={onChange || formik.handleChange}
            onBlur={formik.handleBlur}
            error={Boolean(error)}
            disabled={disabled}
            sx={{
              ...(inputClassName?.includes('fixWidthDropdown') && {
                width: "100%",
                maxWidth: 300 
              }),
              "& .MuiSelect-select span::before": {
                color: "#808080",
                content: `"${placeholder || "-- Select --"}"`,
              },
            }}
            MenuProps={{
              PaperProps: {
                sx: {
                  ...(inputClassName?.includes('fixWidthDropdown') && {
                    width: '100%',
                    maxWidth: 300,
                    '& .MuiMenuItem-root': {
                      whiteSpace: 'normal',
                      wordBreak: 'break-word',
                    }
                  })
                }
              }
            }}
          >
            <MenuItem value="" disabled>
              <em>{placeholder || "Select"}</em>
            </MenuItem>
            {options.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </SelectField>
            {error && <FormHelperText error>{helperText}</FormHelperText>}
            {extraNote ?
             <Typography
      variant="body2"
      color="#FB9D2C"
      className="absolute -bottom-4 left-0 text-xs"
    >
      <b>Note:</b>: {extraNote}
    </Typography>:''}
          </>
        );
      case "radio":
        return (
          <>
            <RadioGroup
              name={name}
              value={_dynmicFormik("values")}
              onChange={formik.handleChange}
              className={label ? "mt-3" : ""}
              row={row ?? true}
            >
              {options.map((option) => (
                <FormControlLabel
                  key={option.value}
                  name={name}
                  value={option.value}
                  disabled={disabled}
                  control={<Radio color="info" />}
                  label={option.label}
                  className="mr-5 mb-0"
                />
              ))}
            </RadioGroup>
            {error && <FormHelperText error>{helperText}</FormHelperText>}
          </>
        );
      case "checkbox":
      case "switch":
        return (
          <>
            <FormGroup className={`${label ? "mt-3" : ""}`} row>
              {options.map((option) => {
                const props = {
                  color: "info",
                  name: name,
                  value: option.value,
                  checked:
                    option?.checked ||
                    _dynmicFormik("values")?.includes(option.value),
                  onChange: (e) => {
                    const { checked } = e.target;
                    const currentValues = _dynmicFormik("values");
                    
                    const newValues = checked
                      ? [...currentValues, option.value]
                      : currentValues?.filter((v) => v !== option.value);
                    formik.setFieldValue(name, newValues);
                    if(onChange)
                      onChange(e)
                  },
                };
                return (
                  <FormControlLabel
                    key={option.value}
                    control={
                      type == "checkbox" ? (
                        <Checkbox {...props} />
                      ) : (
                        <IosSwitch {...props} />
                      )
                    }
                    disabled={disabled}
                    label={option.label}
                    className={`mr-4 mb-3 pt-2 ${boundary ? 'w-full border border-gray-300 rounded-lg px-2 py-1 mt-3 items-center':''}` }
                  />
                );
              })}
            </FormGroup>
            {error && <FormHelperText error>{helperText}</FormHelperText>}
          </>
        );
      case "date":
        return (
          <div className="relative">
            <DatePickerField
              className={inputClassName}
              handleChange={(date) =>
                onChange || formik.setFieldValue(name, date)
              }
              label={label}
              value={_dynmicFormik("values")}
              InputId={name}
              InputName={name}
              placeholder={placeholder}
              disabled={disabled}
              minDate={min}
              maxDate={max}
              showMonthYearPicker={showMonthYearPicker}
              format={format}
              onBlur={(date) => onChange || formik.setFieldValue(name, date)}
             {...((props.position  || name === 'apheresis_date' || name === 'infusion_date')? {
              popperContainer: ({ children }) => (
            <div style={{ position: props.position === 'top' ? 'absolute' : 'fixed',
              top: props.position === 'top' ? 0 : undefined,
                  zIndex: 1600
               }}
              >
              {children}
            </div>
          )
        } : {})}
                />
            {(Boolean(error) || helperText) && (
              <span className="absolute top-[4.3rem] input_error">
                {helperText}
              </span>
            )}
          </div>
        );

      case "date-range":
        return (
           <div className="relative">
            <CustomDateRangePicker
              InputId={name}
              value={_dynmicFormik("values")}
              selectedDate={formik?.values}
              disabled={disabled}
              minDate={min}
              maxDate={max}
              format={format}
              handleDateChange={(range) => {
                formik?.setFieldValue(name, range);
              }}
              hidePresets={formik?.isHidePresets}
              centeredPicker={formik?.isCenteredPicker}
            />
            {(Boolean(error) || helperText) && (
              <span className="absolute top-[4.3rem] input_error">
                {helperText}
              </span>
            )}
            </div>
          );
														
      case "file": {
        const fileValues = _dynmicFormik("values");
        const fileInputRef = useRef(null);
        const [isUploading, setIsUploading] = useState(false);
        const [previewOpen, setPreviewOpen] = useState(false);
        const [filePreview, setFilePreview] = useState("");
        const hasError = _dynmicFormik("touched") && Boolean(_dynmicFormik("errors"));
        const handleDownload = async (id) => {
          const url = await downloadFile(id);
          setFilePreview(url);
          setPreviewOpen(true);
        };

        useEffect(() => {
          if (hasError) {
            if (fileInputRef.current) {
              fileInputRef.current.value = "";
            }
          }
        }, [hasError]); 

        return (
          <div className="mt-6">
            {fileValues?.length !== 0 && disabled ?
             (
             ( fileValues?.length || fileValues?.file_name) ? '' :
             <h5 className="font-medium mt-1"> No File Uploaded</h5>
            ) : (
              <>
                <input
                  type="file"
                  name={name}
                  multiple={multiple}
                  ref={fileInputRef}
                  onChange={async (e) => {
                    setIsUploading(true);
                    try {
                      const files = Array.from(e.target.files);
                      if (onChange) {
                        await onChange(e); // support async
                      } else {
                        if (multiple) {
                          const existingFiles = fileValues || [];
                          formik.setFieldValue(name, [
                            ...existingFiles,
                            ...files,
                          ]);
                        } else {
                          formik.setFieldValue(name, files[0]);
                        }
                      }
                    } finally {
                      setIsUploading(false);
                    }
                  }}
                  style={{
                    ...(disabled && {
                      backgroundColor: "#F0F1F5",
                      color: "#5c5959",
                    }),
                    border: "1px solid",
                    padding: "18px",
                  }}
                  onBlur={(e) => {
                    const files = e.target.files;
                    if (files && files.length > 0) {
                      formik.handleBlur(e);
                    }
                  }}
                  disabled={disabled}
                  accept={acceptFormat?.join(",")}
                  className={`border w-100 rounded-md p-2 border-gray-300
                      file:mr-4 file:py-2 file:px-4 file:rounded-md file:border-0 file:text-sm file:font-semibold
                      ${
                        disabled
                          ? "file:bg-[#F0F1F5] file:text-[#5c5959]"
                          : "file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"
                      }
                      ${inputClassName}`}
                  {...props}
                />

                {/* Loader */}
                {isUploading && (
                  <div className="mt-2 flex items-center gap-2 text-blue-600">
                    <div className="w-100">
                      <LinearProgress color="info" />
                    </div>
                    <span>Uploading...</span>
                  </div>
                )}
              </>
            )}
            {fileValues && downloadFile && (
              <div>
                {Array.isArray(fileValues)
                  ? fileValues?.map((file, index) => (
                      file ? 
                      <div
                        key={index}
                        className="flex items-center justify-between bg-gray-100 p-2 rounded mb-1"
                      >
                        <span className="truncate max-w-xs">
                          {file?.name || file?.file_name} (
                          {Math.round(file?.size || file?.file_name / 1024)} KB)
                        </span>
                        <div className="flex gap-2">
                          <div
                            className={
                              disabled ? " disable-add-visit-btn" : " "
                            }
                          >
                            <Tooltip title="Delete">
                              <span>
                                <IconButton
                                  disabled={disabled}
                                  onClick={() => {
                                    fileInputRef.current.value = null
                                    if (removeFile) {
                                      removeFile(name, file?.id);
                                    } else {
                                      const newFiles = [...fileValues];
                                      newFiles.splice(index, 1);
                                      formik.setFieldValue(
                                        name,
                                        newFiles.length ? newFiles : []
                                      );
                                    }
                                  
                                  }}
                                >
                                  <DeleteIconButton
                                    bgColor={"#FA5151"}
                                    disabled={disabled}
                                  />
                                </IconButton>
                              </span>
                            </Tooltip>
                          </div>
                          {file?.id && ( <>
                            <Tooltip title="View">
                              <span>
                                <IconButton
                                  onClick={() => handleDownload(file?.id)}
                                >
                                  <EyeIconButton bgColor={"#3571FF"} />
                                </IconButton>
                              </span>
                            </Tooltip>
                             <DownloadFiles
                        fileId={file?.id}
                        fileName={file?.file || file?.file_name}
                      /></>
                          )}
                        </div>
                      </div>:''
                    ))
                  : fileValues && (
                      <div className="flex mt-2 items-center justify-between bg-gray-100 p-2 rounded">
                        <span className="truncate max-w-xs">
                          {fileValues?.name || fileValues?.file_name} (
                          {Math.round(
                            fileValues?.size || fileValues?.file_size / 1024
                          )}{" "}
                          KB)
                        </span>
                        <div className="flex gap-2">
                          <Tooltip title="Delete">
                            <span>
                              <IconButton
                                disabled={disabled}
                                onClick={() => {
                                  fileInputRef.current.value = null;
                                  if (removeFile) {
                                    removeFile(name, fileValues?.id);
                                  } else {
                                    formik.setFieldValue(name, null);
                                  }
                                }}
                              >
                                <DeleteIconButton
                                  bgColor={"#FA5151"}
                                  disabled={disabled}
                                />
                              </IconButton>
                            </span>
                          </Tooltip>
                          {fileValues?.id && ( <>
                            <Tooltip title="View">
                              <span>
                                <IconButton
                                  onClick={() => handleDownload(fileValues?.id)}
                                >
                                  <EyeIconButton bgColor={"#3571FF"} />
                                </IconButton>
                              </span>
                            </Tooltip>
                             <DownloadFiles
                        fileId={fileValues?.id}
                        fileName={fileValues?.file || fileValues?.file_name}
                        iconColor="#2F5597"
                      />
                         </> )}
                        </div>
                      </div>
                    )}
              </div>
            )}
            <FilePreviewModal
              ModalTitle={"File Preview"}
              setOpen={setPreviewOpen}
              open={previewOpen}
              fileURL={filePreview}
            />
            {error && <FormHelperText error>{helperText}</FormHelperText>}
          </div>
        );
      }

      default:
        return null;
    }
  };

  return (
    <FormControl variant={variant} fullWidth={fullWidth} className={className}>
      {label && (
        <FormLabel shrink required={required}>
          {label}
        </FormLabel>
      )}
      {renderField()}
    </FormControl>
  );
};

export default FormikControl;
